import { useForm } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { authService } from '@/services/authService';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { isSubmitting } } = useForm();
  const onSubmit = async (data) => {
    if (data.password !== data.confirm) return toast.error('Passwords do not match');
    try {
      await authService.resetPassword(token, { password: data.password });
      toast.success('Password reset. Sign in with your new password.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not reset password');
    }
  };
  return (
    <div className="card p-8">
      <h2 className="text-2xl font-bold">Set a new password</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 mt-6">
        <div>
          <label className="label">New password</label>
          <input type="password" className="input" {...register('password', { required: true, minLength: 6 })} />
        </div>
        <div>
          <label className="label">Confirm password</label>
          <input type="password" className="input" {...register('confirm', { required: true })} />
        </div>
        <button type="submit" disabled={isSubmitting} className="btn-primary w-full">
          {isSubmitting ? 'Saving...' : 'Reset password'}
        </button>
      </form>
      <div className="text-sm text-slate-500 mt-4 text-center">
        <Link to="/login" className="text-brand-600 hover:underline">Back to sign in</Link>
      </div>
    </div>
  );
}
